import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { ChatUser, User } from '@betterleap/client';
import camelCase from 'lodash/camelCase';
import { useEffect } from 'react';
import { getFullName } from '../helper/name.helper';

export const useInitializeLaunchDarkly = ({
  user,
  chatUser,
}: {
  user?: User;
  chatUser?: ChatUser;
}) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (!user && !chatUser) {
      return;
    } else {
      // indentify launch darkly
      if (user) {
        ldClient?.identify({
          kind: 'multi',
          user: {
            key: user.id,
            name: getFullName(user),
            email: user.email,
            role: user.roles[0],
          },
          organization: {
            key: user.organizationId,
            name: user.organization?.name,
            domain: user.organization?.domain,
            tier: user.organization?.tier,
            orgType: user.organization?.orgType,
          },
          group: {
            key: user.groupId,
          },
        });
      } else if (chatUser) {
        ldClient?.identify({
          kind: 'multi',
          chatUser: {
            key: chatUser.id,
            email: chatUser.email,
            role: chatUser.role,
            firebaseId: chatUser.firebaseId,
          },
        });
      }
    }
  }, [user, chatUser]);
};

export enum FeatureFlagKey {
  HEALTHCARE_NLS_PROMPTS = 'healthcare-nls-prompts',
  HEALTHCARE_SOURCING_FILTERS = 'healthcare-sourcing-filters',
  CANDIDATE_MESSAGING = 'candidate-messaging',
  CONTACT_CHAT = 'contact-chat',
  ACTIVE_USER_STATS = 'active-user-stats',
  RELEASE_HOME_INDIVIDUAL_FILTER = 'release-home-individual-filter',
  RELEASE_JOB_BOARD = 'release-job-board',
}

export const useFeatureFlag = (flagName: FeatureFlagKey) => {
  const flags = useFlags();
  return flags[camelCase(flagName)];
};
